// src/components/mediaKit/PlatformIcon.jsx
import React from 'react';

const ICONS = {
    amazon: (
        <svg viewBox="0 0 24 24" width="100%" height="100%"><path d="M5 8h14l-1 11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 8z" fill="#fff" /><path d="M9 8V6a3 3 0 0 1 6 0v2" fill="none" stroke="#FF9900" strokeWidth="1.8" strokeLinecap="round" /></svg>
    ),
    youtube: (
        <svg viewBox="0 0 24 24" width="100%" height="100%"><rect x="2" y="6" width="20" height="12" rx="3" fill="#fff" /><path d="M10 9.5v5l4.5-2.5z" fill="#FF0000" /></svg>
    ),
    tiktok: (
        <svg viewBox="0 0 24 24" width="100%" height="100%"><path d="M14 3v9.2a2.8 2.8 0 1 1-2.8-2.8h.8V7a5.6 5.6 0 1 0 5.6 5.6V8.8c1.1.7 2.3 1.1 3.4 1.1V7c-2 0-3.7-1-4.6-2.4l-.2-.3-.2-.3z" fill="#fff" /></svg>
    ),
    instagram: (
        <svg viewBox="0 0 24 24" width="100%" height="100%"><rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="#fff" strokeWidth="2" /><circle cx="12" cy="12" r="4" fill="none" stroke="#fff" strokeWidth="2" /><circle cx="17.5" cy="6.5" r="1.2" fill="#fff" /></svg>
    ),
    website: (
        <svg viewBox="0 0 24 24" width="100%" height="100%"><circle cx="12" cy="12" r="9" fill="none" stroke="#fff" strokeWidth="2" /><path d="M3 12h18M12 3c2.5 3 3.8 6 3.8 9s-1.3 6-3.8 9c-2.5-3-3.8-6-3.8-9s1.3-6 3.8-9z" fill="none" stroke="#fff" strokeWidth="2" /></svg>
    ),
    facebook: (
        <svg viewBox="0 0 24 24" width="100%" height="100%"><path d="M14 8h2V5h-2c-2.2 0-4 1.8-4 4v2H8v3h2v6h3v-6h2.2l.8-3H13v-2c0-.6.4-1 1-1z" fill="#fff" /></svg>
    ),
    custom: (
        <svg viewBox="0 0 24 24" width="100%" height="100%"><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1.5 1.5" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" /><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1.5-1.5" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" /></svg>
    ),
};

const GRADIENTS = {
    amazon: 'linear-gradient(135deg, #FFB84D, #FF9900)',
    youtube: 'linear-gradient(135deg, #FF4D4D, #CC0000)',
    tiktok: 'linear-gradient(135deg, #25F4EE, #FE2C55)',
    instagram: 'linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)',
    website: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
    facebook: 'linear-gradient(135deg, #3b5998, #1877f2)',
    custom: 'linear-gradient(135deg, #a855f7, #ec4899)',
};

export default function PlatformIcon({ platform = 'custom', size = 28 }) {
    return (
        <span
            className="inline-flex items-center justify-center rounded-full shrink-0"
            style={{ width: size, height: size, background: GRADIENTS[platform] || GRADIENTS.custom, padding: size * 0.22 }}
        >
            {ICONS[platform] || ICONS.custom}
        </span>
    );
}